// extracted by mini-css-extract-plugin
export default {"checkbox":"tQUPNzFrzJQhebAIQcqT"};